export const transactionsConstants =
{
    FETCH_USER_TRANS_REQUEST: "FETCH_USER_TRANS_REQUEST",
    FETCH_USER_TRANS_SUCCESS: "FETCH_USER_TRANS_SUCCESS",
    FETCH_USER_TRANS_FAILURE: "FETCH_USER_TRANS_FAILURE",
    SET_DB_TRANS: "SET_DB_TRANS"


};
